// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "电力系统自动化",
      "tec": "高阳冷雪敏",
      "week": "8-18周",
      "add": "教学楼C座304教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "赵传钰",
      "week": "17-18周",
      "add": "教学楼C座214教务"
    },
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "电气CAD",
      "tec": "张皓男",
      "week": "9,11,13,15,17周",
      "add": "实训楼C座308"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "电能计量",
      "tec": "魏子康",
      "week": "6,8-18周",
      "add": "教学楼C座214教务"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "电力系统自动化",
      "tec": "高阳冷雪敏",
      "week": "8,10,12,14,16周",
      "add": "教学楼C座304教务"
    },
    0,
    0,
    {
      "sub": "电气CAD",
      "tec": "张皓男",
      "week": "8-18周",
      "add": "实训楼C座318"
    },
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
